<template>
    <div class="min-height">
        <div class="card">
            <div class="card-header">
                <div class="media mt-3">
                    <img
                        v-if="user[USERS.fields.profilePictureURL]"
                        :src="user[USERS.fields.profilePictureURL]"
                        class="align-self-center mr-3 border"
                        alt="Store Logo"
                        width="96"
                    />
                    <div class="media-body">
                        <h4 class="card-title mb-0">
                            {{ user[USERS.fields.email] }}
                        </h4>
                        <p class="hint mt-0">{{ user.id }}</p>
                    </div>
                </div>
            </div>
            <div class="card-body d-flex flex-column">
                <div class="row my-3">
                    <div class="col-xl-6">
                        <p class="hint mb-0">Created On</p>
                        <h6>{{ addedDate }}</h6>
                    </div>
                    <div class="col-xl-6">
                        <p class="hint mb-0">Name</p>
                        <h6>{{ name }}</h6>
                    </div>
                    <div class="col-xl-6">
                        <p class="hint mb-0">Phone Number</p>
                        <h6><phone-number :value="user[USERS.fields.phoneNumber]"></phone-number></h6>
                    </div>
                    <div class="col-xl-6">
                        <p class="hint mb-0">Date of Birth</p>
                        <h6>{{ dob }}</h6>
                    </div>
                    <div v-if="user.address" class="col-xl-12 my-2">
                        <p class="hint mb-1">Preferred Address</p>
                        <p class="mb-0">{{ user.address[USER_ADDRESSES.fields.address1] }}</p>
                        <p v-if="user.address[USER_ADDRESSES.fields.address2]" class="mb-0">{{ user.address[USER_ADDRESSES.fields.address2] }}</p>
                        <p class="mb-0">
                            {{ user.address[USER_ADDRESSES.fields.city] }} {{ user.address[USER_ADDRESSES.fields.province] }}
                            {{ user.address[USER_ADDRESSES.fields.postalCode] }}
                        </p>
                        <p>{{ user.address[USER_ADDRESSES.fields.country] }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { USERS, USER_ADDRESSES } from 'db'
export default {
    props: {
        user: {
            type: [Object, Boolean],
            required: true
        }
    },
    data() {
        return {
            USERS,
            USER_ADDRESSES
        }
    },
    computed: {
        addedDate() {
            return this.user[USERS.fields.createdAt]
                ? new Date(this.user[USERS.fields.createdAt]).toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' })
                : 'N/A'
        },
        dob() {
            return this.user[USERS.fields.DOB]
                ? new Date(this.user[USERS.fields.DOB]).toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' })
                : 'N/A'
        },
        name() {
            let name = this.user[USERS.fields.firstName] ? this.user[USERS.fields.firstName] : ''
            name += ' '
            name += this.user[USERS.fields.lastName] ? this.user[USERS.fields.lastName] : ''
            return name
        }
    }
}
</script>

<style lang="scss" scoped>
.card {
    height: 100%;
}
.min-height {
    min-height: 542px;
}
.p-badge {
    margin-right: 0.25rem;
}
th {
    width: 300px;
}
</style>
